/** 与后端 TenantModuleApi.BIZ_MODE_* 对齐，禁止页面里散落模式字符串。 */
export const MALL_BIZ_MODE = {
  PLATFORM: 'platform',
  SELF: 'self'
} as const

export type MallBizMode = (typeof MALL_BIZ_MODE)[keyof typeof MALL_BIZ_MODE]

export function isPlatformMallBizMode(mode?: string | null) {
  return mode === MALL_BIZ_MODE.PLATFORM
}
